import { render, staticRenderFns } from "./CloneProductModal.vue?vue&type=template&id=27f8e04e"
import script from "./CloneProductModal.vue?vue&type=script&lang=js"
export * from "./CloneProductModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports